import React from "react"
import { KEY_TEMP_AF, LOCAL_LOGIN_LANGUAGE, LOCAL_USER_EMAIL } from "../../utils/storage"
import { ExclamationOutlined } from "@ant-design/icons"
import { message, Checkbox, Input, Button } from "antd"
import "./index.less"
import { loadTextsLocalStorage } from "../../utils/i18n"

export class TwoFactorAuthComponent extends React.Component {
  constructor() {
    super()

    this.state = {
      email: "",
      error: false,
      logoLoaded: false,
      two_factor_auth_code: "",
      errorMessage: "",
      resentCounter: 60, // seconds in screen
      intervalTimer: 0,
      logginIn: false,
    }

    this.rememberDevice = false

    this.refCaptchaBadge = React.createRef()

    this.intl = loadTextsLocalStorage("login")
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalTimer)
  }

  setRememberDevicer(value) {
    this.rememberDevice = value
  }

  render() {
    this.setTime()
    const content = () => (
      <form
        className="form-two-factor-auth"
        onSubmit={(e) => e.preventDefault()}>
        <div>{this.intl.twoFactorAuth.checkEmail} ✉️</div>
        <div className="form-two-factor-auth-email-container">
          {this.intl.twoFactorAuth.weSentACode}
          <span className="form-two-factor-auth-email-label">
            {LOCAL_USER_EMAIL()}
          </span>
        </div>

        <div className="two-factor-auth-code-container">
          <Input
            type="text"
            className="two-factor-auth-code-input"
            placeholder={this.intl.twoFactorAuth.enterCode}
            name="two_factor_auth_code"
            onChange={(e) => {
              this.setState({ two_factor_auth_code: e.target.value })
            }}
          />
        </div>
        <div className="two-factor-auth-checkbox-container">
          <Checkbox
            onChange={(e) => this.setRememberDevicer(e.target.checked)}
          />{" "}
          {this.intl.twoFactorAuth.rememberDevice}
        </div>
        <div className="two-factor-auth-resent-container">
          {this.intl.twoFactorAuth.didntReceiveCodeActive}
          {this.state.resentCounter == 0 ? (
            <a
              className="two-factor-auth-link-resent"
              onClick={() => this.resentTwoFactorEmail()}>
              {this.intl.twoFactorAuth.action}
            </a>
          ) : (
            this.intl.twoFactorAuth.action
          )}{" "}
          {this.intl.twoFactorAuth.didntReceiveCodeActiveTwo}{this.state.resentCounter}{this.intl.twoFactorAuth.seconds}
        </div>
        <div>
          <Button
            type="button"
            className="two-factor-auth-code-button"
            onClick={() => this.handleSubmit()}
            loading={this.props.loading}>
            {this.intl.twoFactorAuth.continue}
          </Button>
        </div>
      </form>
    )

    return (
      <div className="loginContainerC">
        {this.state.error ? (
          <div className="errorMessage">
            <div className="circle">
              <ExclamationOutlined />
            </div>
            <p style={{ color: "white" }}>{this.state.errorMessage}</p>
          </div>
        ) : null}
        <div className="loginForm">
          <img
            onLoad={() => {
              this.setState({ logoLoaded: true })
            }}
            src={this.props.img}
            className="logoLogin"
          />
          {this.state.logoLoaded ? content() : <div />}
        </div>
      </div>
    )
  }

  handleSubmit = () => {
    if (this.props.loading) {
      return
    }

    if (this.state.two_factor_auth_code === "") {
      message.error(this.intl.twoFactorAuth.enterCodeAlert)
      return false
    }

    const { email, password, remember, recaptchaToken } = JSON.parse(
      sessionStorage.getItem(KEY_TEMP_AF)
    )

    const payload = {
      email,
      password,
      remember,
      recaptchaToken,
      two_factor_auth_code: this.state.two_factor_auth_code,
      remember_two_factor_auth_code: this.rememberDevice,
      loginLanguage: LOCAL_LOGIN_LANGUAGE(),
    }

    this.props.login(payload)
  }

  setTime = () => {
    if (this.state.intervalTimer == 0) {
      this.state.intervalTimer = setInterval(this.countDown, 1000)
    }
  }

  countDown = () => {
    let seconds = this.state.resentCounter - 1
    this.setState({
      resentCounter: seconds,
    })

    if (seconds == 0) {
      clearInterval(this.state.intervalTimer)
    }
  }

  resentTwoFactorEmail = () => {
    this.state.intervalTimer = 0
    this.setState({
      resentCounter: 60,
    })

    const { email } = JSON.parse(sessionStorage.getItem(KEY_TEMP_AF))

    const payload = {
      email,
    }

    this.props.resend(payload)
  }
}

export default TwoFactorAuthComponent
